module.exports = __webpack_public_path__ + "static/img/default_user.cddba5a6.png";